// Module
var code = "<span>\n    <i class=\"icon-edit_icon\" ng-click=\"editSource($parent.row)\"></i>\n    <i class=\"icon-trash\" ng-click=\"deleteSource($parent.row)\"></i>\n</span>";
// Exports
module.exports = code;